import React from "react";

/**
 * Visual meter for Confidence (0-100) and Concern (0-100) scores.
 * Signature component of The Context Project.
 */
export default function ScoreMeter({ label, value = 0, kind = "confidence", description, size = "md" }) {
    const pct = Math.max(0, Math.min(100, Number(value) || 0));

    const isConcern = kind === "concern";
    // Confidence: blue gradient (#2F80ED -> #56CCF2)
    // Concern: gradient that goes from highlight blue -> warm slate (still calm, never alarmist)
    const fillStyle = isConcern
        ? { background: "linear-gradient(90deg, #56CCF2 0%, #94A3B8 60%, #E2B95C 100%)" }
        : { background: "linear-gradient(90deg, #2F80ED 0%, #56CCF2 100%)" };

    const valueColor = isConcern ? "text-[#E2B95C]" : "text-[#56CCF2]";
    const heightClass = size === "sm" ? "h-2" : "h-3";
    const valueSize = size === "sm" ? "text-xl" : "text-3xl sm:text-4xl";

    return (
        <div data-testid={`score-meter-${kind}`} className="w-full">
            <div className="flex items-baseline justify-between mb-3">
                <span className="text-xs uppercase tracking-[0.18em] text-[#94A3B8] font-medium">
                    {label}
                </span>
                <span className={`${valueSize} font-bold tracking-tighter ${valueColor}`} data-testid={`score-meter-value-${kind}`}>
                    {pct}
                    <span className="text-sm text-[#64748B] ml-0.5">/100</span>
                </span>
            </div>
            <div className={`w-full ${heightClass} rounded-full bg-[#0B1220] border border-[#243044] overflow-hidden`}>
                <div
                    className={`${heightClass} rounded-full meter-fill`}
                    style={{ width: `${pct}%`, ...fillStyle }}
                />
            </div>
            {description && (
                <p className="mt-2 text-xs text-[#64748B] leading-relaxed">{description}</p>
            )}
        </div>
    );
}
